import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import ToggleColorMode from './components/app';
import store from './app/store';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';

// Must run before the app renders. Without a DSN the SDK stays disabled
// (e.g. local dev), so only initialise when one is embedded at build time.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2
  });
}

// Minimal fallback shown when a render error crashes the tree. The error
// itself is reported to Sentry by the ErrorBoundary below.
function ErrorFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: 24
      }}
    >
      <h2>Something went wrong</h2>
      <p>An unexpected error occurred. Please refresh the page and try again.</p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 24px',
          fontSize: 16,
          borderRadius: 6,
          border: 'none',
          background: '#1976d2',
          color: '#fff',
          cursor: 'pointer'
        }}
      >
        Refresh
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <ToggleColorMode />
      </Sentry.ErrorBoundary>
    </Provider>
  </React.StrictMode>
);

//serviceWorkerRegistration.register();
// reportWebVitals();
